import React, { Component, ErrorInfo, ReactNode } from "react";

type Props = {
  children: ReactNode;
  fallback?: ReactNode;
};

type State = { hasError: boolean };

/**
 * Catches ApexCharts errors (e.g. logarithmic undefined) so one chart
 * doesn't block the whole page
 */
export default class ChartErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.warn("[ChartErrorBoundary]", error.message, info.componentStack);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div className="p-3 text-muted small border rounded">
            Chart could not be loaded.
          </div>
        )
      );
    }
    return this.props.children;
  }
}
